export default __webpack_public_path__ + "static/media/Nikhil_kherajani_cv.848fb0ab.pdf";